/*
 * @Author: Josselin Hubert
 * @Date: 2020-09-02 13:30:48
 * @Last Modified by: Josselin Hubert
 * @Last Modified time: 2020-09-02 13:44:35
 */


<template>
  <section id="hero">
    <!-- :src="require('@/assets/simple-header-blended-small.png')" -->
    <!-- gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)" -->
    <base-jumbotron :src="require('@/assets/AdobeStock-small.png')"
                    gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .5)"
                    class="white--text"
                    height="50vh">
      <v-row align="center"
             class="pb-12 white--text">
        <v-col cols="12"
               md="8">
          <div>
            <base-title>
              {{$t('panel.skills.title')}}
            </base-title>

            <v-divider class="mb-10" />

            <div class="subheading mb-4">
              <p>{{$t('panel.skills.subtitle1')}}</p>

              <p> {{$t('panel.skills.subtitle2')}} </p>
            </div>
          </div>
        </v-col>
      </v-row>
    </base-jumbotron>
  </section>
</template>

<script>
  export default {
    name: "SkillsHero",
  };
</script>
